import { Pipe, PipeTransform } from '@angular/core';
import { RoutingService } from 'src/app/services/routing-service';

@Pipe({ name: 'richurl' })
export class RichUrlPipe implements PipeTransform
{
    private routingService: RoutingService;

    public constructor(routingService: RoutingService)
    {
        this.routingService = routingService;
    }

    public transform(value: any, ...args: any[])
    {
        const query = this.routingService.getRequestQuery();
        if (query.length === 0)
        {
            return value;
        }

        const querySeparator = value.indexOf('?') > -1 ? '&' : '?';
        return `${value}${querySeparator}${query}`;
    }
}
